var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "XS Icon Search",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 19.537 19.537"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2377",
    fill: "none",
    d: "M0 0h19.537v19.537H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11726",
    clipPath: "url(#search_svg__a)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 316",
    cx: 7.467,
    cy: 7.467,
    r: 7.467,
    transform: "translate(.75 .75)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 78",
    d: "M13.497 13.497l5.29 5.29"
  }))));
}
export default SvgSearch;